import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useState } from "react";
import { getCarrierList } from "services/data.internal.service";
import { getShipingZoneList } from "services/data.internal.service";
import { FormTitle,Text,SelectField } from "ui-components/Form";

function InfoCustCarrier({ formRender, control, errors, getValues, mode = "ADD" }) {
  const newItem = getValues("newItem")
  const [shippingZoneOption, setShippingZoneOptions] = useState([]);
  const [carrierCodeOptions, setCarrierCodeOptions] = useState([]);
  useQuery({
    queryKey: ["shipping-zone-options"],
    queryFn: () => getShipingZoneList({active:true}),
    onSuccess: (data) => {
      const options = data.data.data.map((v) => v.shippingZone);
      setShippingZoneOptions(options);
    },
  });

  useQuery({
    queryKey: ["carrier-options"],
    queryFn: () => getCarrierList({active:true}),
    onSuccess: (data) => {
      const options = data.data.data.map((v) => v.carrierCode);
      setCarrierCodeOptions(options);
    },
  });
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Customer Carrier Information" : "Customer Carrier Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, size, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(newItem===false&&editable === false && { disabled: true,type:"text" })
              };
              let renderField;
              console.log(fieldProps.type)
              switch (fieldProps.type) {
                case "text":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "shippingZone":
                      options = shippingZoneOption
                      break;
                    case "carrierCode":
                    case "b2BCarrierCode":
                      options = carrierCodeOptions
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
              }

              return (
                <Grid item xs={4} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default InfoCustCarrier;